import { IonIcon } from "@ionic/react";
import axios from "axios";
import { logoWhatsapp } from "ionicons/icons";
import React, { useEffect, useState } from "react";
import { useHistory } from "react-router";
import StyledButton from "../../components/basicsComponents/StyledButton/StyledButton";
import ModalPacienteForm from "../../components/formComponents/ModalFormPaciente/ModalFormPaciente";
import CustomToast from "../../components/basicsComponents/CustomToast/CustomToast";
import LoadingBackdrop from "../../components/basicsComponents/LoadingBackdrop/LoadingBackdrop";
import {
  Column,
  Container,
  Row,
} from "../../components/basicsComponents/MaterialGridComponents";
import {
  Box,
  Button,
  Card,
  CardContent,
  Divider,
  Link,
  Typography,
} from "@mui/joy";
import CustomInput from "../../components/basicsComponents/CustomInput/CustomInput";
import { Visibility, VisibilityOff } from "@mui/icons-material";
import useTituloPagina from "../../hooks/tituloPagina";

const LoginIonic = () => {
  const MENSAJE_ERROR_CREDENCIALES =
    "Error al consultar los datos del paciente. Verifique si el usuario y contraseña están registrados.";
  const [cargando, setCargando] = useState(false);
  const [blnVerPassword, setBlnVerPassword] = useState(false);
  const [usuario, setUsuario] = useState({
    usuario: "",
    password: "",
    token: "",
  });
  const [urlAxioPP, setUrlAxio] = useState("");
  const [tituloPagina, setTituloPagina] = useState("");
  const [errorUsuario, setErrorUsuario] = useState(false);
  const [errorPassword, setErrorPassword] = useState(false);
  const [msjErrorPassword, setMsjErrorPassword] = useState("");
  const [registrarPaciente, setRegistrarPaciente] = useState(false);
  const [toast, setToast] = useState({ open: false, mensaje: "", tipo: "" });
  const mostrarNotificacion = (abrir, mensaje, tipo) => {
    let notificacion = {};
    if (abrir) {
      notificacion = { open: true, mensaje: mensaje, tipo: tipo };
    } else {
      notificacion = { open: false, mensaje: "", tipo: "" };
    }
    setToast(notificacion);
  };

  const history = useHistory();
  useTituloPagina();

  const handleChangeVisibilityOfPassword = () => {
    setBlnVerPassword(!blnVerPassword);
  };

  useEffect(() => {
    setUrlAxio(localStorage.getItem("urlAxioPP"));
    setTituloPagina(localStorage.getItem("nombreClinica"));

    document.title = localStorage.getItem("tituloWeb");
    sessionStorage.removeItem("ppUL");
  }, []);

  const loginPaciente = async (usuario, password) => {
    try {
      const response = await axios.post(`${urlAxioPP}Usuarios/LoginPaciente`, {
        nombreUsuario: usuario,
        password: password,
      });
      return response.data.token;
    } catch (error) {
      console.error("Error en loginPaciente:", error);
      setErrorPassword(true);
      setMsjErrorPassword("Documento o contraseña incorrecto");
      mostrarNotificacion(true, MENSAJE_ERROR_CREDENCIALES, "rojo");
    }
  };

  const obtenerPaciente = async (token, documento) => {
    try {
      const config = {
        headers: { Authorization: `Bearer ${token}` },
      };
      const response = await axios.get(
        `${urlAxioPP}Pacientes?documento=${documento}`,
        config,
      );

      const data = response.data[0];

      if (!data) {
        mostrarNotificacion(
          true,
          "No se encontraron datos del paciente en la respuesta.",
          "rojo",
        );
        return null;
      }

      const pacienteCompleto = {
        usuario: usuario.usuario,
        password: usuario.password,
        token: token,
        codigo: data.codigo,
        hc: data.hc,
        documentoNro: data.documentoNro,
        documentoTipo: data.documentoTipo,
        documentoTipoNombre: data.documentoTipoNombre,
        nombre: data.nombre,
        apellido: data.apellido,
        mutual: data.mutual,
        mutualNombre: data.mutualNombre,
        telefono: data.telefono,
        celular: data.celular,
        email: data.email,
        mutualAfiliado: data.mutualAfiliado,
        nacimiento: data.nacimiento,
      };

      return pacienteCompleto;
    } catch (error) {
      console.error("Error en petición obtenerPaciente:", error);
      mostrarNotificacion(true, MENSAJE_ERROR_CREDENCIALES, "rojo");
      return null;
    }
  };

  const handleClickLogin = async () => {
    setCargando(true);

    if (usuario.usuario !== "" && usuario.password !== "") {
      const token = await loginPaciente(usuario.usuario, usuario.password);

      if (!token) {
        setCargando(false);
        return;
      }

      const paciente = await obtenerPaciente(token, usuario.usuario);

      if (paciente) {
        mostrarNotificacion(true, "Sesión iniciada correctamente", "verde");
        setUsuario(paciente);
        sessionStorage.setItem("ppUL", JSON.stringify(paciente));
        history.push("/portal/Inicio");
      }
    } else {
      if (usuario.usuario === "") setErrorUsuario(true);
      if (usuario.password === "") {
        setErrorPassword(true);
        setMsjErrorPassword("Debe ingresar su contraseña");
      }
    }
    setCargando(false);
  };

  const handleClickSubmit = () => {
    setCargando(true);
    handleClickLogin();
    setCargando(false);
  };

  const handleClickRegistrarse = (event) => {
    event.preventDefault();
    setRegistrarPaciente(true);
  };

  const handleChangeUsuario = (e) => {
    const value = e.target.value;
    //Reemplazamos los valores no numericos por espacios en blanco
    const filteredValue = value.replace(/[^0-9]+/g, "");
    setErrorUsuario(false);
    setUsuario({ usuario: filteredValue, password: usuario.password });
  };

  const handleChangePassword = (e) => {
    const value = e.target.value;
    //Reemplazamos los valores no numericos por espacios en blanco
    const filteredValue = value.replace(/[^0-9]+/g, "");
    setErrorPassword(false);
    setUsuario({ usuario: usuario.usuario, password: filteredValue });
  };

  const handleClickCopiarTelefono = () => {
    const phoneNumber = "0810-555-2765";
    navigator.clipboard.writeText(phoneNumber);

    mostrarNotificacion(
      true,
      "Se ha copiado el número de telefono a su portapapeles",
      "",
    );
  };

  return (
    <Container
      direction="column"
      justifyContent="space-between"
      alignItems="center"
      style={{
        height: "100vh",
      }}
    >
      <Row item="true"></Row>
      <Row
        item="true"
        style={{ backgroundImage: "assets/imagendefondoLogin.webp" }}
      >
        <Card style={{ width: "350px" }}>
          <CardContent>
            <Row container spacing={2} rowGap={2}>
              <Column xs={12}>
                <Box display="flex" justifyContent="center" mb={2}>
                  <img
                    alt="Logo clinica"
                    src="assets/icon/logo.jpg"
                    width={"60%"}
                  />
                </Box>
                <Typography level="title-lg" align="center">
                  {"Portal del paciente".toUpperCase()}
                </Typography>
                <form
                  noValidate
                  autoComplete="off"
                  style={{ marginBottom: "7.5px" }}
                >
                  <CustomInput
                    fullWidth
                    margin="normal"
                    value={usuario.usuario}
                    onChange={handleChangeUsuario}
                    error={errorUsuario}
                    startDecorator={
                      <Typography
                        variant="plain"
                        color="neutral"
                        sx={{ width: "100px" }}
                      >
                        Documento:
                      </Typography>
                    }
                  />
                  <CustomInput
                    fullWidth
                    margin="normal"
                    startDecorator={
                      <Typography
                        variant="plain"
                        color="neutral"
                        sx={{ width: "100px" }}
                      >
                        Contraseña:
                      </Typography>
                    }
                    endDecorator={
                      <React.Fragment>
                        <Divider orientation="vertical" />
                        <Button
                          onClick={handleChangeVisibilityOfPassword}
                          type="button"
                          variant="plain"
                          color="neutral"
                        >
                          {blnVerPassword ? <Visibility /> : <VisibilityOff />}
                        </Button>
                      </React.Fragment>
                    }
                    type={blnVerPassword ? "text" : "password"}
                    value={usuario.password}
                    onChange={handleChangePassword}
                    error={errorPassword}
                    helperText={
                      "Si no cambio su contraseña, ingrese su número de documento"
                    }
                    errorHelperText={msjErrorPassword}
                  />
                  <CustomInput
                    fullWidth
                    variant="solid"
                    color="primary"
                    type="button"
                    onClick={handleClickSubmit}
                    disabled={cargando}
                    value={"Ingresar"}
                    sx={{
                      backgroundColor: "#B50009",
                      color: "#fff",
                      appearance: "button",
                      WebkitAppearance: "button",
                      "&:hover": {
                        backgroundColor: "#ed576b",
                      },
                      "&:disabled": {
                        backgroundColor: "#ed576b",
                        color: "#888",
                      },
                    }}
                  />
                </form>
                <Typography level="body-xs" paddingInline={1}>
                  {
                    "Si es la primera vez que te vas a atender con nosotros, debes registrarte o comunicarte mediante nuestro WhatsApp."
                  }
                </Typography>
                <button
                  type="button"
                  onClick={handleClickRegistrarse}
                  disabled={cargando}
                  style={{
                    width: "100%",
                    minHeight: "40px",
                    marginTop: "8px",
                    border: 0,
                    borderRadius: "8px",
                    backgroundColor: cargando ? "#ed576b" : "#B50009",
                    color: cargando ? "#888" : "#fff",
                    cursor: cargando ? "default" : "pointer",
                    fontFamily: "inherit",
                    fontSize: "0.875rem",
                    fontWeight: 700,
                  }}
                >
                  Registrarse
                </button>

                <StyledButton
                  className="verde"
                  expand="block"
                  fill="clear"
                  onClick={handleClickCopiarTelefono}
                  href={
                    "https://api.whatsapp.com/send?phone=+5493515079642&text=Hola%2C%20me%20ponía%20en%20contacto%20para%20registrarme%20como%20paciente."
                  }
                  target="_blank"
                >
                  <IonIcon icon={logoWhatsapp} />
                </StyledButton>
              </Column>
            </Row>
          </CardContent>
        </Card>
      </Row>
      <Row item="true">
        <Link
          href="https://www.gacitua.com.ar/"
          rel="Proveedor del servicio noreferrer"
          target="_blank"
        >
          <Typography level="title-lg">
            <Typography color="neutral"> {"Powered by "}</Typography>
            <img
              src={"assets/logoGacitua.png"}
              alt="logo gacitua y asociados"
              width={17}
              height={17}
            />
            <Typography> {" Gacitua & Asociados"}</Typography>
          </Typography>
        </Link>
      </Row>

      {registrarPaciente && (
        <ModalPacienteForm
          mostrarNotificacion={mostrarNotificacion}
          openModal={registrarPaciente}
          setOpenModal={setRegistrarPaciente}
        />
      )}

      <CustomToast
        openToast={toast.open}
        onDidDismiss={() => mostrarNotificacion(false, "", "")}
        message={toast.mensaje}
        colorNotificacion={toast.tipo}
      />

      {cargando && <LoadingBackdrop visualizar={cargando} />}
    </Container>
  );
};

export default LoginIonic;
